import React from 'react'

import api from '@disco/api/server'

import LoginForm from 'components/common/login-form'
import { Box } from 'components/ds'

import type { AddToDiscoUser } from '../types'

type Props = {
  user: AddToDiscoUser
  onLoginUser: (...args: Array<any>) => any
  onForgotPassword: (email: string, returnUrl: string) => Promise<any>
  onGetSignUpUrl: () => Promise<string>
}

const AddToDiscoLoginForm = ({
  user,
  onLoginUser,
  onForgotPassword,
  onGetSignUpUrl,
}: Props): React.ReactNode => {
  return (
    <Box p="3">
      <LoginForm
        user={user}
        // @ts-expect-error TODO: fix this
        location={location}
        message="Sign in to add this music to your DISCO"
        onLoginUser={onLoginUser}
        onForgotPassword={onForgotPassword}
        onSamlDiscovery={async email => {
          return await api.samlLogin({
            username: email.trim(),
            redirect_uri: window.location.href,
          })
        }}
        onGetSignupUrl={onGetSignUpUrl}
      />
    </Box>
  )
}

export default AddToDiscoLoginForm
